import { SimpleFormDialog } from '@procureai/ui-modules-mui';
import { useTranslation } from 'react-i18next';

import { SavingForm } from '../SavingForm/SavingForm';
import { createSavingFormSchema, savingFormDefaultValues, SavingFormData } from '../SavingForm/SavingForm.schema';
import { I18nNamespace } from '~/common/types';

import { useCreateSavingBackend } from './useCreateSavingBackend';

interface CreateSavingDialogProps {
  open: boolean;
  onClose: () => void;
}

export const CreateSavingDialog = ({ open, onClose }: CreateSavingDialogProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'Savings' });

  const backend = useCreateSavingBackend();

  return (
    <SimpleFormDialog<SavingFormData>
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      useBackend={() => backend}
      title={t('createDialog.title')}
      schema={createSavingFormSchema}
      defaultValues={savingFormDefaultValues}
      submitLabel={t('createDialog.submitLabel')}
      cancelLabel={t('createDialog.cancelLabel')}
      slotProps={{
        content: { className: 'w-[calc(100vw-2rem)] sm:max-w-3xl' },
      }}
    >
      {({ saving }) => <SavingForm mode="create" disabled={saving} />}
    </SimpleFormDialog>
  );
};
